/* LB 24-09-2026 — ficha de producto, escritorio: galería compacta (4 fotos + "Ver todas las fotos").
   El tema clona las 16 fotos dos veces para el carrusel infinito del móvil; en escritorio esas 48 celdas se pintaban
   en cuadrícula y empujaban las reseñas 12.000 px abajo. Aquí solo marcamos clases; el CSS está en lb-pdp-24-09.css. */
(function () {
  'use strict';
  var SHOW = 4; /* 24-09 tarde: 4 fotos (2 filas). Con 6 la galería era más alta que la columna de info y dejaba ~230 px vacíos entre "Compartir" y las reseñas */
  function mark() {
    if (window.innerWidth < 990) return;
    var list = document.querySelector('.product__media-list');
    if (!list) return;
    var items = Array.prototype.slice.call(list.querySelectorAll('.product__media-item'));
    var originals = items.filter(function (i) { return i.getAttribute('data-lb-clone') !== 'true'; });
    originals.forEach(function (it, idx) { it.classList.toggle('lb-media-extra', idx >= SHOW); });
    var total = originals.length;
    var btn = document.querySelector('.lb-gallery-more');
    if (total > SHOW && !btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'lb-gallery-more';
      btn.textContent = 'Ver todas las fotos (' + total + ')';
      btn.addEventListener('click', function () { document.body.classList.add('lb-gallery-all'); });
      var host = list.closest('slider-component') || list;
      host.insertAdjacentElement('afterend', btn);
    } else if (btn && total <= SHOW) {
      btn.remove();
    }
  }
  /* 24-09 noche: cabecera e iniciales del bloque de reseñas (solo presentación; el contenido no cambia). CSS en lb-pdp-24-09.css (7)
     05-10 (Ayoub): el título pasa a "Reseñas generales" (son reseñas de toda la tienda, no de ese producto).
     05-10 tarde (Ayoub): se quita la frase "Basado en N reseñas" de este bloque (quedan la nota y las estrellas). El resumen de arriba, bajo el título, no se toca. */
  function reviews() {
    var wall = document.querySelector('.lb-review-wall');
    if (!wall || wall.getAttribute('data-lb-rv') === '1') return;
    wall.setAttribute('data-lb-rv', '1');
    var top = wall.querySelector('.lb-review-wall__top');
    /* Milo ya incorpora su propio encabezado y resumen compacto. Evita duplicar
       el bloque global "Reseñas generales" en esa ficha; el resto de la tienda no cambia. */
    var isMiloReviewWall = wall.classList.contains('lb-review-wall--milo');
    if (top && !isMiloReviewWall) {
      /* resumen tipo Loox/Judge.me con la nota que YA muestra la ficha (resumen bajo el título) */
      var sum = document.querySelector('.lb-product-review-summary');
      var txt = sum ? sum.textContent.replace(/\s+/g, ' ') : '';
      var rating = (txt.match(/(\d[.,]\d)/) || [])[1] || '';
      var head = document.createElement('div');
      head.className = 'lb-rv-head';
      var h = '<h2 class="lb-rv-title">Reseñas generales</h2>';
      if (rating) {
        h += '<div class="lb-rv-sum"><div class="lb-rv-sum__num">' + rating + '</div><div><div class="lb-rv-sum__stars" aria-hidden="true">★★★★★</div></div></div>';
      }
      head.innerHTML = h;
      top.insertBefore(head, top.firstChild);
    }
    Array.prototype.forEach.call(wall.querySelectorAll('.lb-review-wall__name'), function (n) {
      if (n.querySelector('.lb-rv-avatar')) return;
      var name = (n.textContent || '').trim();
      var ini = name.split(/\s+/).slice(0, 2).map(function (w) { return w.charAt(0).toUpperCase(); }).join('');
      var av = document.createElement('span');
      av.className = 'lb-rv-avatar';
      av.setAttribute('aria-hidden', 'true');
      av.textContent = ini || '•';
      n.insertBefore(av, n.firstChild);
    });
  }
  function init() {
    /* 25-09 (Ayoub): el bloque de reseñas igual en toda la web (home incluida) */
    reviews();
    window.setTimeout(reviews, 1500);
    if (!document.body.classList.contains('lb-product')) return;
    mark();
    [300, 900, 2000, 4000].forEach(function (d) { window.setTimeout(mark, d); });
    window.addEventListener('resize', mark, { passive: true });
    if (window.MutationObserver) {
      var list = document.querySelector('.product__media-list');
      if (list) new MutationObserver(function () { window.requestAnimationFrame(mark); }).observe(list, { childList: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
